import { api } from '@/f1/service';
import codes from '@/f1/codes';
import Result from '../../result/Result.Detail.i18n'
import { VclFacebook } from 'vue-content-loading';

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

export default {
  components : {
    Result,
    VclFacebook,
  },
  data : () => {
    return { model : { agent_id : { name : '', host : '' } }, codes, loading : false, agentName : '' }
  },
  methods: {
    result() {
      this.$router.push({ name: 'wsfinder_result', params : { id : this.model.result.id }});
    },
    agent() {
      this.$router.push({ name: 'wsfinder_agent', params : { id : this.model.agent_id }});
    },
    list() { this.$router.push({ name: 'wsfinder_detect'}); },
    async get({ id } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; this.model = Object.assign({}); return; }
      try {
        this.loading = true
        let rs = await api.wsfinder.WSFinder_Call('detect', 'detail', {id : id});
        //let rs = await wf.detect.detail({id : id})
        this.model = Object.assign({ group: {} }, this.model, rs.body)
        this.model.description = JSON.parse(rs.body.description);

        if(this.model.description && this.model.description.type == 'ML') {
          this.model.description.type = 'Ai'
        }

      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }

      finally {
        this.loading = false
      }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params, from); } },
  created: function() {   console.log('detect.detail.vue', 'created'); },
  destroyed: function() { console.log('detect.detail.vue', 'destroyed'); },
  mounted: function() { console.log('detect.detail.vue', 'mounted'); this.get(this.$route.params); },
}
